import gql from 'graphql-tag';

export const priceSummaryFragments = {
    TravelerPriceSummary: gql`
        fragment PriceSummaryTravelerPriceSummary on TravelerPriceSummary {
                priceTypeId
                edapEventJson
                formattedAmount
                roundedFormattedAmount
                pricePeriodDescription
        }
    `
};

export default priceSummaryFragments;
